import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { makeQAAttributes } from '../../../../utils/qaAttributes';
import { QA_TABS } from '../../../../constants/qaAttributes';

const Tab = ({ tab, changeTabHandler }) => {
  const changeTab = () => {
    changeTabHandler(tab.type);
  };

  return (
    <div className="sp-tabs__item">
      <button
        {...makeQAAttributes(`${QA_TABS.ITEM}-${tab.type}`)}
        className={classNames('sp-tabs__control', { 'is-active': tab.isActive })}
        style={{ width: '100%' }}
        role="tab"
        tabIndex="-1"
        disabled={tab.total === 0}
        onClick={changeTab}
      >
        <span className="sp-tabs__text">
          {tab.title}
          &nbsp;
        </span>
        {tab.total && (
          <span className="sp-tabs__text sp-tabs__text--count">
            (
            {tab.total}
            )
          </span>
        )}
      </button>
    </div>
  );
};

Tab.propTypes = {
  tab: PropTypes.shape({
    type: PropTypes.string.isRequired,
    isActive: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    total: PropTypes.number,
  }).isRequired,
  changeTabHandler: PropTypes.func.isRequired,
};

export default Tab;
